<template>
  <div>
    <p class="mb-0">
      <v-chip
        v-if="
          item_transactionable.match(/AffiliateTransaction/g) &&
            item_type == 'debit'
        "
        class="ma-2"
        color="purple"
        text-color="white"
        small
      >
        รับค่าแนะนำ
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/TicketNumber/g) && item_type == 'credit'
        "
        class="ma-2"
        color="light"
        small
      >
        ยกเลิกรายการ
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/TicketNumber/g) && item_type == 'debit'
        "
        class="ma-2"
        color="light-blue"
        text-color="white"
        small
      >
        ชนะพนัน
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/Ticket$/g) && item_type == 'credit'
        "
        class="ma-2"
        color="brown"
        text-color="white"
        small
      >
        แทง/เล่นเกม
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/Ticket$/g) && item_type == 'debit'
        "
        class="ma-2"
        color="light"
        small
      >
        คืนโพย
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/CashTransaction/g) &&
            item_type == 'credit'
        "
        class="ma-2"
        color="red"
        text-color="white"
        small
      >
        ถอนเครดิต
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/CashTransaction/g) && item_type == 'debit'
        "
        class="ma-2"
        color="green lighten-1"
        text-color="white"
        small
      >
        เติมเครดิต
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/CreditTransaction/g) &&
            item_type == 'accom-debit'
        "
        class="ma-2"
        color="success"
        small
      >
        สรุปยอดเครดิต
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/CreditTransaction/g) &&
            item_type == 'accom-credit'
        "
        class="ma-2"
        text-color="white"
        color="red"
        small
      >
        สรุปยอดเครดิต
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/DirectDebitTransaction/g) &&
            item_type == 'debit'
        "
        class="ma-2"
        color="teal"
        text-color="white"
        small
      >
        เติมตรง
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/DirectDebitTransaction/g) &&
            item_type == 'credit'
        "
        class="ma-2"
        color="light"
        small
      >
        ยกเลิกฝากตรง
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/VIPLevelBonus/g) && item_type == 'debit'
        "
        class="ma-2"
        color="pink lighten-1"
        text-color="white"
        small
      >
        รับโบนัส VIP
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/GambleGame/g) && item_type == 'debit'
        "
        class="ma-2"
        color="pink lighten-1"
        text-color="white"
        small
      >
        รับโบนัสยิงเลข
      </v-chip>

      <v-chip
        v-else-if="
          item_transactionable.match(/CreditBack/g) && item_type == 'debit'
        "
        class="ma-2"
        color="pink lighten-1"
        text-color="white"
        small
      >
        คืนยอดเสีย
      </v-chip>
    </p>
    <p
      v-if="item_remark"
      class="mb-0 d-inline-block"
      style="font-size: 0.8em; max-width: 230px; word-wrap: break-word"
      :title="item_remark"
    >
      {{ item_remark }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'CreditType',
  props: {
    item_type: { required: true },
    item_transactionable: { required: true },
    item_remark: { required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
